module.exports = __webpack_public_path__ + "img/treatmentPlan-x.e3ce66c5.svg";